import React, { useEffect } from "react";
import FormComponent from "../components/FormComponent";
import Aos from "aos";
import 'aos/dist/aos.css'

function Banner() {
    useEffect(() => {
        Aos.init({
            once: true,
            duration: 500,
        });
    }, [])
    return (
        <>
            <section id="banner" className="position-relative">
                <div className="bg-shape">
                    <div className="container-lg g-0 px-md-2">
                        <div className="row g-0">
                            <div className="col-md-7 col-xl-8 position-relative z-3 banner-wrapper">
                                <div className="bannerlist px-3 px-lg-0 mt-3 mt-md-0">
                                    <h1 data-aos="fade-up" data-aos-delay="100" data-aos-duration="800"><span>For Every Professional <br className="" />
                                        Who Deserves More. </span></h1>
                                    <p className="subtitle only_desk" data-aos="fade-up" data-aos-delay="200" data-aos-duration="800">Premium benefits and superior  experiences
                                        reserved for you.</p>
                                </div>
                                <div className="featlist px-3 px-lg-0">
                                    <div data-aos="fade-up" data-aos-delay="300" data-aos-duration="800">
                                        <img src="dist/img/icons/banner2.svg" alt="" width={28} height={28} className="iconimg" />
                                        <p>₹2,700* worth  <br className="d-lg-none"/>Activation Vouchers.</p>
                                    </div>
                                    {/* <div className="only_desk" data-aos="fade-up" data-aos-delay="400" data-aos-duration="800">
                                        <img src="dist/img/icons/banner1.svg" alt="" width={28} height={28} className="iconimg" />
                                        <p>Incredible Rewards,  <br className="d-lg-none" />Every Day via iShop.</p>
                                    </div> */}
                                    <div data-aos="fade-up" data-aos-delay="500" data-aos-duration="800">
                                        <img src="dist/img/icons/banner3.svg" alt="" width={28} height={28} className="iconimg" />
                                        <p>Up to ₹500* worth  <br className="d-lg-none" />Movie Ticket Benefits.</p>
                                    </div>
                                    <div className="no-fee" data-aos="fade-up" data-aos-delay="600" data-aos-duration="800">
                                        <img src="dist/img/img_no_fee1.svg" alt="" width={170} height={70} />
                                    </div>
                                </div>
                                <img src="dist/img/banner_lady.webp" alt="" className="desktop_men" data-aos="fade-in" data-aos-delay="600" data-aos-duration="800" />
                                <img src="dist/img/cards_m.webp" width={358} height={261} alt="cards" className="cards cards_m img-fluid d-lg-none" data-aos="fade-up" data-aos-delay="600" data-aos-duration="800" data-aos-offset="0" />
                                <img src="dist/img/cards.webp" width={672} height={273} alt="cards" className="cards img-fluid d-none d-lg-block" data-aos="fade-up" data-aos-delay="600" data-aos-duration="800" data-aos-offset="0" />
                            </div>
                            <div className="col-md-5 col-xl-4 px-3 position-relative">
                                <FormComponent></FormComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Banner;
